import { z } from "zod";

export const taskFormSchema = z.object({
	// TODO: Define your schema fields here
});

export const getTaskSchema = z.object({
	id: z.string(),
});

export type TaskFormType = z.infer<typeof taskFormSchema>;
export type GetTaskType = z.infer<typeof getTaskSchema>;
